import React, { useEffect, useMemo, useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  Checkbox,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { assetFamilyMaster, columnsTemplateCheckList, ServiceTemplateMaster, ServiceTypeType, TemplateColumnMaster } from "../../types/assetTypes";
import { getCountryAssetMasterDataList, getFamilyAssetMasterDataList, getServiceTemplateByIdData, getServiceTemplateList, getServiceTypeList, getTemplateList, saveServiceTemplate } from "../../api/Services/masterServie";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";
import ImagePreview from "../../Component/ImagePreview";
import { RootState } from "../../store/Reduxstore";
import { getUniqueAssetNamesByFamilyId } from "../../api/Services/assetServices";

interface CreatetTemplateProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  serviceTemplateId: number | null;
  setServiceTemplateId: React.Dispatch<React.SetStateAction<number | null>>;
  userId: number;
}

const CreateTemplate: React.FC<CreatetTemplateProps> = ({ setOpen, serviceTemplateId,
  setServiceTemplateId,
  userId, }) => {
  const dispatch = useDispatch();
  const [serviceTemplate, setServiceTemplate] = useState<ServiceTemplateMaster>({
    serviceTemplateId: 0,
    serviceTemplateName: "",
    familyAssetId: 0,
    familyAssetName: "",
    columns: [], // Assuming `columns` is an array used in the table
  });

  interface ServiceColumnMap {
    familyAssetId: number;
    assetName: string[];   // multiple asset names
  }


  const [faultAssetMapData, setFaultAssetMapData] = useState<ServiceColumnMap>({
    familyAssetId: 0,
    assetName: [],
  });

  const [serviceTypes, setServiceTypes] = useState<ServiceTypeType[]>([]);
  const [templateColumns, setTemplateColumns] = useState<TemplateColumnMaster[]>([]);
  const [familyAsset, setFamilyAsset] = useState<assetFamilyMaster[]>([]);
  const [assetName, setAssetNameList] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    if (familyAsset.length === 0) getFamilyAssetList(1, PAGESEND);
  }, [familyAsset]);

  useEffect(() => {
    if (serviceTemplate) {
      console.log("Current Service Template:", serviceTemplate);

      serviceTemplate.columns?.forEach((column, columnIndex) => {
        console.log(`Column ${columnIndex + 1}:`, column);

        column.serviceTypeStatuses?.forEach((status) => {
          console.log(
            ` - ServiceTypeId: ${status.serviceTypeId}, isChecked: ${status.isChecked}`
          );
        });
      });
    }
  }, [serviceTemplate]);


  interface ServiceColumnMap {
    familyAssetId: number;
    assetName: string[]; // multiple asset names
  }

  useEffect(() => {
    if (serviceTemplateId !== null && serviceTemplateId !== 0) {
      getServiceTemplateById();
    }
  }, [serviceTemplateId]);

  const getServiceTemplateById = async () => {
    if (!serviceTemplateId) {
      CustomMessage("Service ID not selected", "error", enqueueSnackbar);
      return;
    }

    dispatch(setLoading(true));

    try {
      const response = await getServiceTemplateByIdData(serviceTemplateId);
      console.log("API Response:", response);

      const rawData = response.data?.data || response.data;

      if (rawData) {
        const combinedData = {
          ...rawData,
          userId: userId ?? 0,
          columns: rawData.columns?.map((col: any) => ({
            ...col,
            assets: col.assets ?? [], // ensure assets array exists
          })) || [],
          assetName: [] as string[], // initialize assetName as empty array
        };


        if (combinedData.familyAssetId) {
          setFaultAssetMapData(prev => (
            {
              ...prev,
              familyAssetId: combinedData.familyAssetId
            }
          ));
          const assetNames = await getAssetNameList(combinedData.familyAssetId); // assuming this returns string[]
          combinedData.assetName = assetNames;
        }



        console.log("Setting serviceTemplate:", combinedData);

        await getServiceTemplateData({
          //serviceTemplateId: combinedData.serviceTemplateId,
          assetName: [],
          familyAssetId: combinedData.familyAssetId,
        });
        setServiceTemplate(combinedData);
      } else {
        CustomMessage("No data found for template ID", "warning", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message || "Failed to fetch data", "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  useEffect(() => {
    const fetchServiceTypes = async () => {
      try {
        const response = await getServiceTypeList(PAGESTART, PAGESEND, {});
        setServiceTypes(response.data); // Set service types dynamically
      } catch (error) {
        console.error("Failed to fetch service types:", error);
      }
    };
    fetchServiceTypes();
  }, []);


  const [currentLocation, setCurrentLocation] = useState<
    { label: string; value: number }[]
  >([]);



  useEffect(() => {
    if (currentLocation.length === 0) getCurrentLocationList(1, PAGESEND);
  }, [currentLocation]);


  const getCurrentLocationList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getCountryAssetMasterDataList(page, rows, { currentLocationId: { value: "", matchMode: "startsWith" } });
      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.currentLocationId,
          label: val.countryName,
        }));
        updatedData.unshift({ label: "--Select--", value: 0 });
        setCurrentLocation(updatedData);
        console.log("Mapped location data:", updatedData);

      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getAssetNameList = async (familyAssetId: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);
      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        const updatedData = data.map((assetName: string) => ({
          value: assetName,
          label: assetName,
        }));
        updatedData.unshift({ label: "--Select--", value: "" });
        setAssetNameList(updatedData);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };





  const getFamilyAssetList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getFamilyAssetMasterDataList(page, rows, { familyAssetId: { value: "", matchMode: "startWith" } });
      if (status.code === 200 && data?.length > 0) {
        setFamilyAsset(data);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const [isEditMode, setIsEditMode] = useState(false);




  interface ServiceColumnMap {
    familyAssetId: number;
    assetName: string[]; // multiple asset names
  }

  const getServiceTemplateData = async (payload: ServiceColumnMap) => {
    dispatch(setLoading(true));

    try {
      const response = await getServiceTemplateList(payload);
      const { data, status } = response;

      if (status.code === 200 && data && data.length > 0) {
        // ensure assets always exists
        const mappedData: TemplateColumnMaster[] = data.map((d) => ({
          ...d,
          assets: d.assets ?? [],
        }));

        setTemplateColumns(mappedData);

        setServiceTemplate((prev) => {
          if (!prev) return prev;

          const updatedData: columnsTemplateCheckList[] = data.map((column) => {
            const existingColumn = prev.columns.find(
              (col) => col.templateColumnId === column.templateColumnId
            );

            const serviceTypeStatuses = serviceTypes.map((type) => {
              const match = existingColumn?.serviceTypeStatuses?.find(
                (s) => s.serviceTypeId === type.serviceTypeId
              );
              return {
                serviceTypeId: type.serviceTypeId,
                isChecked: match?.isChecked ?? false,
              };
            });

            return {
              ...column,
              attachments: existingColumn?.attachments || [],
              serviceTypeStatuses,
            };
          });

          return {
            ...prev,
            columns: updatedData,
          };
        });
      } else {
        CustomMessage(status.message, 'error', enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, 'error', enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const handleCheckboxChange = (key: string, index: number, value: boolean) => {
    if (!serviceTemplate) return;
    const updatedServiceTemplate = { ...serviceTemplate };
    const updatedData = [...updatedServiceTemplate.columns];
    updatedData[index] = {
      ...updatedData[index],
      [key]: value
    };
    updatedServiceTemplate.columns = updatedData;
    setServiceTemplate(updatedServiceTemplate);
  };
  const userDetails = useSelector((state: RootState) => state.auth)
  console.log(userDetails);

  const handleClear = () => {
    setServiceTemplateId(0);
    setOpen(false);
  }

  //console.log(serviceTemplate,'serviceTemplate',selectedData,'selectedData');
  const handleSave = async () => {
    if (!serviceTemplate) return;
    if (!serviceTemplate.familyAssetId || serviceTemplate.familyAssetId === 0) {
      CustomMessage("Please select a Family Asset.", "error", enqueueSnackbar);
      return;
    }
    if (!serviceTemplate.serviceTemplateName.trim()) {
      CustomMessage("Service Template Name is required.", "error", enqueueSnackbar);
      return;
    }

    const hasChecked = serviceTemplate.columns.some((col) =>
      col.serviceTypeStatuses?.some((type) => type.isChecked)
    );

    if (!hasChecked) {
      CustomMessage("Please check at least one service type.", "error", enqueueSnackbar);
      return;
    }


    dispatch(setLoading(true));
    try {
      const payload = {
        ...serviceTemplate,
        userId: userDetails.userId ?? 0,
        columns: serviceTemplate.columns.map((col) => ({
          templateColumnId: col.templateColumnId,
          templateColumnName: col.templateColumnName,
          attachments: col.attachments || [],
          serviceTypeStatuses: col.serviceTypeStatuses.filter((s) => s.isChecked),
          assets: [],
        })),

      };
      const response = await saveServiceTemplate(payload);
      const { data, status } = response;
      if (status.code === 200 || status.code === 201) {
        handleClear();
        CustomMessage(status.message, 'success', enqueueSnackbar);
      } else {
        CustomMessage(status.message, 'error', enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, 'error', enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      {serviceTemplate && (
        <TableContainer
          component={Paper}
          sx={{ maxWidth: "100%", overflowX: "auto", p: 3, boxShadow: 3 }}
        >

          <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            <FormControl sx={{ minWidth: 200 }}>
              <h6 className="mb-1">Select Family</h6>
              {/* <InputLabel>Select Family</InputLabel> */}
              <Select
                value={serviceTemplate.familyAssetId}
                onChange={(e) => {
                  const selectedFamilyId = e.target.value as number;
                  getAssetNameList(e.target.value as number);

                  // update serviceTemplate
                  setServiceTemplate({
                    ...serviceTemplate,
                    familyAssetId: selectedFamilyId,
                  });

                  // update faultAssetMapData
                  setFaultAssetMapData({
                    ...faultAssetMapData,
                    familyAssetId: selectedFamilyId,
                  });
                }}
              >
                {familyAsset.map((asset) => (
                  <MenuItem key={asset.familyAssetId} value={asset.familyAssetId}>
                    {asset.familyName}
                  </MenuItem>
                ))}
              </Select>

            </FormControl>

            <div>
              <InputLabel className="fw-bold">Enter Template Name</InputLabel>
              <TextField
                label=""
                variant="outlined"
                value={serviceTemplate.serviceTemplateName}
                onChange={(e) => setServiceTemplate({ ...serviceTemplate, serviceTemplateName: e.target.value })}
                sx={{ minWidth: 200 }}
              />
            </div>

            <div style={{ display: "inline-flex", minWidth: 200, maxWidth: "100%" }}>
              <FormControl
                fullWidth
                variant="outlined"
                style={{ borderRadius: 5, flex: 1 }}
              >
                <h6 className="mb-1">Asset Types</h6>
                <Select
                  multiple
                  value={faultAssetMapData.assetName || []}
                  onChange={(e) => {
                    const selectedAssets = e.target.value as string[];

                    // Update local state
                    setFaultAssetMapData({
                      ...faultAssetMapData,
                      assetName: selectedAssets,
                    });

                    // Trigger service template fetch
                    if (faultAssetMapData.familyAssetId) {
                      getServiceTemplateData({
                        familyAssetId: faultAssetMapData.familyAssetId,
                        assetName: selectedAssets,
                      });
                    }
                  }}
                  displayEmpty

                  renderValue={(selected: any) => {
                    if (!Array.isArray(selected)) return selected || "Select Asset Types";
                    if (selected.length === 0) return "Select Asset Types";

                    // Show max 3, rest as "+x more"
                    const displayItems = selected.slice(0, 3);
                    const extraCount = selected.length - displayItems.length;

                    return extraCount > 0
                      ? `${displayItems.join(", ")} (+${extraCount} more)`
                      : displayItems.join(", ");
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        width: 250,
                      },
                    },
                  }}
                >
                  <MenuItem disabled value="">
                    Select Asset Types
                  </MenuItem>
                  {assetName.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

          </div>

          <Table stickyHeader className="custom-table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", background: "#e0e0e0" }}></TableCell>
                {serviceTypes.map((type) => (
                  <TableCell key={type.serviceTypeId} sx={{ fontWeight: "bold", background: "#e0e0e0" }}>
                    {type.serviceTypeName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>



            <TableBody>
              {serviceTemplate.columns.map((col, colIndex) => (
                <TableRow key={colIndex}>
                  <TableCell sx={{ fontWeight: "bold", background: "#f5f5f5" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          border: "1px solid #ccc",
                          overflow: "hidden",
                          backgroundColor: "#f5f5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        {col.attachments?.length > 0 && (
                          <ImagePreview
                            alt="attachment"
                            src={`${FILE_DOWNLOAD_PREVIEW}${col.attachments[0].attachmentId}`}
                            style={{
                              width: "59px",
                              height: "59px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                      <span>{col.templateColumnName}</span>
                    </div>
                  </TableCell>

                  {serviceTypes.map((type, typeIndex) => {
                    const typeStatus = col.serviceTypeStatuses?.find(
                      (s) => s.serviceTypeId === type.serviceTypeId
                    );

                    return (
                      <TableCell key={typeIndex}>
                        <Checkbox
                          checked={typeStatus?.isChecked || false}
                          onChange={(e) => {
                            const updatedColumns = [...serviceTemplate.columns];
                            const columnToUpdate = updatedColumns[colIndex];
                            const updatedStatuses = columnToUpdate.serviceTypeStatuses.map((s) =>
                              s.serviceTypeId === type.serviceTypeId
                                ? { ...s, isChecked: e.target.checked }
                                : s
                            );
                            updatedColumns[colIndex] = {
                              ...columnToUpdate,
                              serviceTypeStatuses: updatedStatuses,
                            };
                            setServiceTemplate({
                              ...serviceTemplate,
                              columns: updatedColumns,
                            });
                          }}
                          color="primary"
                        />
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <div className="d-flex justify-content-end align-items-end gap-2 w-100 mt-3">
            <ReusablePrimeButton
              label="Cancel"
              onClick={handleClear}
              className="btn btn-secondary text-white w120 h-45"
            />
            {userDetails.role.some(
              (r) =>
                r.roleName === "Admin" ||
                r.roleName === "Service Template Write"
            ) && (
                <ReusablePrimeButton
                  label="Save"
                  onClick={handleSave}
                  className="btn btn-primary w120 h-45"
                />
              )}
          </div>
        </TableContainer>
      )}



    </>
  );
};

export default CreateTemplate;
